import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import { GradesDTO } from '../grades/dto/grades.dto';
import { Grades} from '../grades/grades.entity';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { GradesService } from './grades.service';
import { GradesResponseModel, AllGradesResponseModel } from '@gtpl/shared-models/masters';
import { GradeRequest } from './dto/grades.request';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';


@ApiTags('grades')
@Controller('grades')
export class GradesController {

    constructor(
        private gradesService: GradesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createGrade')
    async createGrade(@Body() gradeDto:GradesDTO,isUpdate:boolean=false): Promise<GradesResponseModel> {
    try {
        return await this.gradesService.createGrade(gradeDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(GradesResponseModel, error);
      }
    }
    @Post('/updateGrade')
  async updateGrade(@Body() gradeDto: GradesDTO,@Req() request:Request): Promise<GradesResponseModel> {
    try {
      console.log('update Grade');
      console.log(request);
      return await this.gradesService.createGrade(gradeDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GradesResponseModel, error);
    }
  }
  @Post('/getAllGrades')
  // @UseGuards(AuthGuard('jwt'))
  async getAllGrades(@Body() req?:UserRequestDto): Promise<AllGradesResponseModel> {

    try {
      return await this.gradesService.getAllGrades(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGradesResponseModel, error);
    }
  }
  @Post('/getAllActiveGrades')
  async getAllActiveGrades(@Req() request: Request): Promise<AllGradesResponseModel> {
      try {
          return await this.gradesService.getAllActiveGrades();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllGradesResponseModel, error)
      }
  }
  @Post('/activateOrDeactivateGrade')
  async activateOrDeactivateGrade(@Body() gradeReq: GradeRequest): Promise<GradesResponseModel> {
      try {
          return await this.gradesService.activateOrDeactivateGrade(gradeReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(GradesResponseModel, err);
      }
  }
  @Post('/getGradeById')
  async getGradeById(@Body() gradeReq: GradeRequest): Promise<GradesResponseModel> {
      try {
          return await this.gradesService.getActiveGradeById(gradeReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(GradesResponseModel, err);
      }
  }
}
